import React from 'react';
import PoliciesTable from './PoliciesTable';
import { useFetchPolicies } from '../hooks/DataFetching/useFetchPolicies';
import { useState } from 'react';

export const FetchPolicies = () => {
  const { policies, loading } = useFetchPolicies();
  const [isExpanded, setIsExpanded] = useState(false);

  const toggleExpansion = () => {
    setIsExpanded(prevState => !prevState);
  };

  const contents = loading
    ? <p><em>Loading...</em></p>
    : isExpanded && <PoliciesTable policies={policies} />;

  return (
    <div>
      <h3 id="tabelLabel" className="clickable" onClick={toggleExpansion}>
        Policies
      </h3>
      {contents}
    </div>
  );
};